import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=7a637602&scoped=true"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"
import style0 from "./questions.vue?vue&type=style&index=0&id=7a637602&prod&lang=scss&scoped=true"
import style1 from "./questions.vue?vue&type=style&index=1&id=7a637602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a637602",
  null
  
)

export default component.exports